import { IInteraction } from "../interfaces/IInteraction";

export interface IVideoState {
  watchedVideo: boolean;
}

export default class Video {
  private _id: string;
  private _type: string;
  private _configuration: any;
  private _state: IVideoState;

  get state(): IVideoState {
    return this._state || { watchedVideo: false };
  }
  set state(state: IVideoState) {
    this._state = state;
  }

  constructor(id: string, type: string, conf: any, state: IVideoState) {
    this._configuration = conf;
    this._id = id;
    this._type = type;
    this.state = state;
  }

  renderSlides() {
    const md = {
      id: this._configuration.id,
      friedrichType: this._type,
      friedrichId: this._id,
    };
    const slide = {
      id: this._id,
      data: this._configuration,
      metadata: md,
      type: this._type,
    };

    slide.data["metadata"] = md;

    if (this.state.watchedVideo) slide.data["showSkipButton"] = true;

    return [slide];
  }

  reduceState(interaction: IInteraction): IVideoState {
    this.state = { watchedVideo: true };
    return this.state;
  }
}

module.exports = Video;
